<template>
    <information-popup modal-id="termsConditionsPopup">
        <template slot="header">Terms &amp; Conditions</template>
        <slot>
            <terms-conditions-content class="modal-body"></terms-conditions-content>
        </slot>
    </information-popup>
</template>

<script type="text/jsx">
    import InformationPopup from '@/components/popup/information-popup.vue';
    import TermsConditionsContent from '@/components/content/static/TermsConditions.vue';
    export default {
        name: 'terms-conditions',
        components: {
            'information-popup': InformationPopup,
            'terms-conditions-content': TermsConditionsContent
        }
    }
</script>



// WEBPACK FOOTER //
// TermsConditions.vue?9cedba70